import VueRouter from "vue-router";
import store from "./store";

import Login from "./components/Login";
import Session from "./components/redirects/SessionCheck";
import MyAccount from "./components/account/MyAccount";
import Signout from "./components/account/Signout";
import ServerError from "./components/errors/ServerError";

const routes = [
  {
    path: "/myaccount",
    name: "myaccount",
    component: MyAccount,
    meta: {
      requiresAuth: true,
      title: "One ID"
    }
  },
  {
    path: "/signout",
    name: "signout",
    component: Signout,
    meta: {
      requiresAuth: true,
      title: "One ID"
    }
  },
  {
    path: "/",
    redirect: {
      name: 'myaccount'
    }
  },
  {
    path: "/signin",
    name: "signin",
    component: Login,
    meta: {
      guest: true,
      title: "One ID - Sign in"
    }
  },
  {
    path: "/error",
    name: "error",
    component: ServerError,
    meta: {
      guest: false,
      title: "One ID - Error"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeResolve(async (to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
  if (!store.state.user) {
      next({ name: "signin" });
      return;
    }
  }

  if (to.matched.some(record => record.meta.guest)) {

    if (store.state.user) {
      if(to.query.continue) {
        window.location.href = decodeURIComponent(decodeURI(to.query.continue));
      } else {
        next({ name: "myaccount" });
      }
      return;
    }
  }

  next();
});

export default router;
